import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  VStack,
} from "@chakra-ui/react";
import { GameMode } from "../types";
import StartGameButtons from "./StartGameButtons";

type OutOfTimeModalProps = {
  isOpen: boolean;
  onClose: () => void;
  levelNumber: number;
  setGameMode: (gameMode: GameMode) => void;
  setUnlockedStageTypes: (unlockedStageTypes: string[]) => void;
  setLevelTimer: (levelTimer: number) => void;
  beginNewPuzzle: (mode?: GameMode, worldId?: number) => void;
  selectedWorldId: number;
  setSelectedWorldId: (worldId: number) => void;
  onReturnToTitle?: () => void;
};

const OutOfTimeModal: React.FC<OutOfTimeModalProps> = ({
  isOpen,
  onClose,
  levelNumber,
  setGameMode,
  setUnlockedStageTypes,
  setLevelTimer,
  beginNewPuzzle,
  selectedWorldId,
  setSelectedWorldId,
  onReturnToTitle,
}) => {
  const handleStartGame = () => {
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader
          color="red.500"
          fontSize="5xl"
          fontWeight="bold"
          textAlign="center"
        >
          Boom!
        </ModalHeader>
        <ModalBody textAlign="center">
          You ran out of time! You were on level {levelNumber}. Try again?
        </ModalBody>

        <ModalFooter justifyContent="center">
          <VStack spacing={4} w="100%">
            <StartGameButtons
              onStartGame={handleStartGame}
              setGameMode={setGameMode}
              setUnlockedStageTypes={setUnlockedStageTypes}
              setLevelTimer={setLevelTimer}
              beginNewPuzzle={beginNewPuzzle}
              selectedWorldId={selectedWorldId}
              setSelectedWorldId={setSelectedWorldId}
            />
            {onReturnToTitle && (
              <Button
                variant="ghost"
                onClick={() => {
                  onClose();
                  onReturnToTitle();
                }}
              >
                Return to Menu
              </Button>
            )}
          </VStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default OutOfTimeModal;
